import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../../services/api';
import { FiPlus, FiEdit, FiTrash2, FiX } from 'react-icons/fi';
import './Management.css';

const HeaderImagesManagement = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [editingImage, setEditingImage] = useState(null);
  const [formData, setFormData] = useState({
    file_path: '',
    order: 0,
    is_active: true,
  });

  useEffect(() => {
    loadImages();
  }, []);

  const loadImages = async () => {
    try {
      const response = await adminAPI.getAllHeaderImages();
      setImages(response.data);
    } catch (error) {
      console.error('Error loading header images:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingImage) {
        await adminAPI.updateHeaderImage(editingImage.id, formData);
      } else {
        await adminAPI.createHeaderImage(formData);
      }
      loadImages();
      resetForm();
    } catch (error) {
      alert('Error al guardar la imagen');
      console.error(error);
    }
  };

  const handleEdit = (image) => {
    setEditingImage(image);
    setFormData({
      file_path: image.file_path || '',
      order: image.order || 0,
      is_active: image.is_active,
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta imagen?')) {
      try {
        await adminAPI.deleteHeaderImage(id);
        loadImages();
      } catch (error) {
        alert('Error al eliminar la imagen');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      file_path: '',
      order: 0,
      is_active: true,
    });
    setEditingImage(null);
    setShowForm(false);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setUploadProgress(0);
    try {
      const response = await adminAPI.uploadFile(file, (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);
      });
      setFormData({ ...formData, file_path: response.data.file_path });
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error al subir el archivo');
    } finally {
      setUploading(false);
    }
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="management">
      <div className="management-header">
        <h1>Gestión de Imágenes del Header</h1>
        <button className="btn-primary" onClick={() => setShowForm(true)}>
          <FiPlus /> Nueva Imagen
        </button>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={resetForm}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingImage ? 'Editar' : 'Nueva'} Imagen</h2>
              <button className="close-btn" onClick={resetForm}>
                <FiX />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="form">
              <div className="form-group">
                <label>Imagen *</label>
                <input
                  type="file"
                  onChange={handleFileUpload}
                  accept="image/*"
                />
                {uploading && (
                  <div style={{ marginTop: '10px' }}>
                    <div style={{ width: '100%', backgroundColor: '#eee', borderRadius: '4px', height: '10px' }}>
                      <div
                        style={{
                          width: `${uploadProgress}%`,
                          backgroundColor: '#2563eb',
                          height: '100%',
                          borderRadius: '4px',
                          transition: 'width 0.3s ease'
                        }}
                      />
                    </div>
                    <p style={{ fontSize: '0.8em', color: '#666', textAlign: 'center', marginTop: '5px' }}>Subiendo: {uploadProgress}%</p>
                  </div>
                )}
                <input
                  type="text"
                  value={formData.file_path}
                  readOnly
                  placeholder="La ruta se generará automáticamente"
                  required
                />
                {formData.file_path && (
                  <img src={`/api/files/${formData.file_path}`} alt="Vista previa" className="form-preview" />
                )}
              </div>
              <div className="form-group">
                <label>Orden</label>
                <input
                  type="number"
                  value={formData.order}
                  onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
                />
              </div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.is_active}
                    onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
                  />
                  Activo
                </label>
              </div>
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={resetForm}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Vista Previa</th>
              <th>Ruta</th>
              <th>Orden</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {images.map((image) => (
              <tr key={image.id}>
                <td>{image.id}</td>
                <td>
                  <img
                    src={`/api/files/${image.file_path}`}
                    alt={`Header ${image.id}`}
                    className="table-preview"
                  />
                </td>
                <td className="file-path">
                  {image.file_path.replace(/\.jpg\.jpeg$/i, '.jpeg')}
                </td>
                <td>{image.order}</td>
                <td>{image.is_active ? 'Activo' : 'Inactivo'}</td>
                <td>
                  <button
                    className="btn-icon"
                    onClick={() => handleEdit(image)}
                    title="Editar"
                  >
                    <FiEdit />
                  </button>
                  <button
                    className="btn-icon btn-danger"
                    onClick={() => handleDelete(image.id)}
                    title="Eliminar"
                  >
                    <FiTrash2 />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HeaderImagesManagement;
